import { Component } from "@angular/core";


@Component({
  selector: 'app-oauth',
  standalone: true,
  templateUrl: './oauth.component.html',
  styleUrl: './oauth.component.scss',
})
export class oauthComponent {
 //quiero los query params de la url
  queryParams: any;

  constructor() {
    const urlParams = new URLSearchParams(window.location.search);
    this.queryParams = Object.fromEntries(urlParams.entries());
  }
//console.log(this.queryParams);
  ngOnInit() {
  }
  
}
